import Parser from 'html-react-parser';
import { Users, UserCheck, Coins, HandCoins } from 'lucide-react';
import Card from '../../../common/card';
import Popup from '../../../common/popup';
import { ReactComponent as InfoIcon } from '../../../../assets/icons/info-unfilled.svg';
import l from '../../../../lang';
import { ClientsSummary } from '../../../../store/clients/interfaces';
import { formatTransactedAmountValue } from '../utils';
import './styles.scss';

interface ClientsStatsCardsProps {
  stats?: ClientsSummary;
  loading?: boolean;
}

const formatCountValue = (value?: number) => {
  if (value == null || Number.isNaN(Number(value))) {
    return '0';
  }

  return Number(value).toLocaleString('es-AR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

const ClientsStatsCards = ({ stats, loading }: ClientsStatsCardsProps) => {
  const cards = [
    {
      id: 'total',
      titleKey: 'menu.item.CLIENTS',
      tooltipKey: 'clients.stats.total.tooltip',
      value: formatCountValue(stats?.totalClients),
      icon: <Users size={28} strokeWidth={1.75} aria-hidden />,
      iconVariant: 'total',
    },
    {
      id: 'active',
      titleKey: 'clients.activeClients',
      tooltipKey: 'clients.stats.active.tooltip',
      value: formatCountValue(stats?.activeClients),
      icon: <UserCheck size={28} strokeWidth={1.75} aria-hidden />,
      iconVariant: 'active',
    },
    {
      id: 'volume',
      titleKey: 'clients.transactedVolume',
      tooltipKey: 'clients.stats.volume.tooltip',
      value: formatTransactedAmountValue(stats?.transactedVolume),
      icon: <Coins size={28} strokeWidth={1.75} aria-hidden />,
      iconVariant: 'volume',
    },
    {
      id: 'average',
      titleKey: 'clients.averageClientValue',
      tooltipKey: 'clients.stats.average.tooltip',
      value: formatTransactedAmountValue(stats?.averageClientValue),
      icon: <HandCoins size={28} strokeWidth={1.75} aria-hidden />,
      iconVariant: 'average',
    },
  ];

  return (
    <div className="clients-stats-cards" aria-busy={loading}>
      <div className="clients-stats-cards__grid">
        {cards.map(card => (
          <Card key={card.id} nested className="clients-stats-card">
            <div className="clients-stats-card__tooltip">
              <Popup
                text={Parser(l(card.tooltipKey))}
                icon={<InfoIcon className="clients-stats-card__info-icon" aria-hidden />}
              />
            </div>
            <div className="clients-stats-card__content">
              <div className="clients-stats-card__main">
                <span className="clients-stats-card__title">{l(card.titleKey)}</span>
                <div className={`clients-stats-card__value${loading ? ' clients-stats-card__value--loading' : ''}`}>
                  {loading ? '—' : card.value}
                </div>
              </div>
              <div className={`clients-stats-card__icon-wrap clients-stats-card__icon-wrap--${card.iconVariant}`}>
                {card.icon}
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default ClientsStatsCards;
